import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';

import { addExtra } from './utils';

export default function* listenAddExtra() {
  yield takeEvery(basketActions.addExtra.toString(), addExtra);
}
